var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoll = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.66699 18.3335L18.3337 18.3335L18.3337 1.66683L1.66699 1.66683L1.66699 18.3335ZM3.18214 16.8183L3.18214 3.18198L16.8185 3.18198L16.8185 16.8183L3.18214 16.8183ZM5.45487 14.5456L6.97002 14.5456L6.97002 8.48501L5.45487 8.48501L5.45487 14.5456ZM9.24275 14.5456L10.7579 14.5456L10.7579 5.45471L9.24275 5.45471L9.24275 14.5456ZM13.0306 14.5456L14.5458 14.5456L14.5458 10.0002L13.0306 10.0002L13.0306 14.5456Z",
  fill: "#1051A1"
})));
export default SvgPoll;